export enum CompanySecurityAttributes {
  TWO_FACTOR_AUTHENTICATION = "twoFactorAuthentication",
  LIMIT_LOGON = "limitLogon",
  AUTO_TERMINATION_SESSION = "autoTerminateSession",
  PASSWORD_COMPLEXITY = "passwordComplexity",
  PASSWORD_REUSE = "passwordReuse",
  PASSWORD_RESET = "passwordReset",
  PROHIBIT_SIMULTANEOUS_LOGINS = "prohibitSimultaneousLogins",
  PROHIBIT_LOGIN_DEVICES = "prohibitLoginDevices",
}

export enum Platforms {
  SALES = "sales",
  OPS = "ops",
  WEB = "web",
}
